export const EVT_WIN_BEFOREUNLOAD = 'beforeunload'
export const EVT_WIN_RESIZE = 'resize'

export const EVT_KEYUP = 'keyup'
export const EVT_KEYDOWN = 'keydown'

export const EVT_CLICK = 'click'
export const EVT_MOUSEUP = 'mouseup'
export const EVT_MOUSEOUT = 'mouseout'
export const EVT_MOUSEOVER = 'mouseover'
export const EVT_MOUSEDOWN = 'mousedown'
export const EVT_MOUSEMOVE = 'mousemove'

export const EVT_SCROLL = 'scroll'

export const EVT_DBLCLICK = 'dblclick'
